import { render, staticRenderFns } from "./FreeDayAccepted.vue?vue&type=template&id=6c801a90&"
import script from "./FreeDayAccepted.vue?vue&type=script&lang=js&"
export * from "./FreeDayAccepted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports